// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleRubric_root__3CjTZ","feature":"ArticleRubric_feature__3fxWR","link":"ArticleRubric_link__1eWl6"};